var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUiPlusLtr = function SvgUiPlusLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.999 11.19C52.952 9.42 51.403 8 49.5 8 47.567 8 46 9.465 46 11.273V47H11.28l-.083.001C9.424 47.048 8 48.597 8 50.5c0 1.933 1.468 3.5 3.28 3.5H46v34.727l.001.083C46.048 90.58 47.597 92 49.5 92c1.933 0 3.5-1.465 3.5-3.273V54h35.72l.083-.001C90.576 53.952 92 52.403 92 50.5c0-1.933-1.469-3.5-3.28-3.5H53V11.273z"
  })));
};
export default SvgUiPlusLtr;